//import "bootstrap/dist/css/bootstrap.min.css";
import '@mdi/font/css/materialdesignicons.css';
import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'


const vuetify = createVuetify({
  components,
  directives,

})


createApp(App).use(vuetify).use(store).use(router).mount("#app");
